export default __webpack_public_path__ + "2d19cd66173b9bdbd8173d7ab3942bf2.png";